export default __webpack_public_path__ + "static/media/Cartão de Natal - Opção 02.da8ad159.png";